import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';

import { VatRatesDropdownComponent } from './vat-rates-dropdown.component';
import { RnplCommonModule } from 'common/src/modules';

@NgModule({
  declarations: [
    VatRatesDropdownComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NgSelectModule,
    TranslateModule,
    RnplCommonModule,
  ],
  exports: [VatRatesDropdownComponent],
  entryComponents: [VatRatesDropdownComponent],
})
export class VatRatesDropdownModule { }
